module.exports = {"title":"Why not try us out?","standard_body":"Our new quick sign up takes less than a minute","block_one_title":"Get the new iZettle Reader","block_one_small":"Just £29 + VAT","block_two_title":"Free express delivery","block_two_small":"Order before 11 am and get it tomorrow","block_three_title":"Try it for 30 days","block_three_small_one":"If you’re not a fan, just send it back","block_three_small_two":"that run every 30 minutes 24/7","close":"Close","back":"Back"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/confirmation.json
// module id = 634
// module chunks = 247 1460